import React from 'react';
import './TopAlarmers.css';
import logComponent from '../../common/logComponent';
import TopAlarmers from './TopAlarmers';
import { CardTopAlarmsProvider } from '../../contexts/CardTopAlarmsContext';
 
export default function TopAlarmersCard({ moduleDescription }) {
  if (logComponent('TopAlarmersCard')) { console.debug('TopAlarmersCard rendered'); }


  return (
    <CardTopAlarmsProvider>
      <TopAlarmers moduleDescription={moduleDescription} />
    </CardTopAlarmsProvider>
  );
}